import { z } from "zod";

import { ExperienceDtoSchema } from "../../../dtos/experiences";
import { VariationDtoSchema } from "../../../dtos/variations";

export const PatchBuilderTestGroupsRequestPathParamSchema = z.object({
  experimentId: z.string().uuid(),
});

export type PatchBuilderTestGroupsRequestPathParamType = z.infer<
  typeof PatchBuilderTestGroupsRequestPathParamSchema
>;

export const PatchBuilderTestGroupsRequestBodySchema =
  VariationDtoSchema.array();

export type PatchBuilderTestGroupsRequestBodyType = z.infer<
  typeof PatchBuilderTestGroupsRequestBodySchema
>;

export const PatchBuilderTestGroupsResponseBodySchema = z.object({
  experiences: ExperienceDtoSchema.array(),
});

export type PatchBuilderTestGroupsResponseBodyType = z.infer<
  typeof PatchBuilderTestGroupsResponseBodySchema
>;
